// extracted by mini-css-extract-plugin
export default {"wrapper":"lu-z","addressLine":"mu-z","fullName":"nu-z"};